const stageFilterStyles = {
  formControl: {
    minWidth: 200,
  },
}

export default stageFilterStyles
